<template>
  <div class="lambfoot content-container">
    <a-row
      type="flex"
      style="flex-wrap: wrap-reverse;"
    >
      <a-col
        :xs="24"
        :sm="24"
        :md="5"
      >
        <div
          class="footlogo"
          @click="toHome"
        >
          <img
            :src="logo"
            alt="Lambda"
          >
        </div>
        <div class="footshare">
          <a
            href="https://t.me/HelloLambda"
            target="_blank"
          >
            <img src="../assets/layout/telegram.svg">
          </a>
          <a
            href="https://twitter.com/Lambdaim"
            target="_blank"
          >
            <img src="../assets/layout/twitter (4).svg">
          </a>
          <a
            href="https://discord.gg/lambdastorage"
            target="_blank"
          >
            <img src="../assets/layout/discord.svg">
          </a>
          <a
            href="https://lambdanetwork.medium.com/"
            target="_blank"
          >
            <img src="../assets/layout/medium-new.svg">
          </a>
        </div>
      </a-col>
      <a-col
        :xs="24"
        :sm="24"
        :md="19"
      >
        <div class="ulcon">
          <ul class="ul">
            <li>
              <router-link to="/">
                {{ $t("head.index") }}
              </router-link>
            </li>
          </ul>

          <ul class="ul">
            <li>
              <router-link to="/about">
                {{ $t("head.about") }}
              </router-link>
            </li>
          </ul>

          <ul class="ul">
            <li>
              <a
                href="https://docs.lambda.im/"
                target="_blank"
              >
                {{ $t("head.doc") }}
              </a>
            </li>

            <li>
              <a
                href="https://scan.lambda.im"
                target="_blank"
              >{{
                $t("doc.btn.b1")
              }}</a>
            </li>

            <li class="Legacy-wrap">
              <a href="https://www.lambdastorage.com/">{{ $t("head.legacy") }}</a>
              <span class="Legacy">{{ $t("head.deprecated") }}</span>
            </li>
          </ul>

          <ul class="ul">
            <li>
              <b>{{ $t("head.application") }}</b>
            </li>
            <li>
              <a
                href="https://genify.xyz"
                target="_blank"
              >
                Genify
              </a>
            </li>
            <li>
              <a
                href="https://tagge.xyz"
                target="_blank"
              >
                Tagge
              </a>
            </li>
            <li>
              <a
                href="https://affine.art"
                target="_blank"
              >
                Affine
              </a>
            </li>
          </ul>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import logo from "../assets/home/2.svg";

export default {
  data () {
    return {
      logo
    };
  },
  methods: {
    toHome () {
      this.$router.push("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.ulcon {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.ul {
  list-style-type: none;
  padding-inline-start: 0px;
  // padding-left: 50%;
  display: inline-block;
  padding-left: 40px;
  li {
    font-size: 14px;
    line-height: 23px;
    margin-bottom: 18px;
    font-weight: 500;

    a {
      color: #ffffff;
    }
  }
}
.footlogo {
  margin-bottom: 22px;

  img {
    width: 112px;
    height: 40px;
  }
}

.footshare {
  margin-bottom: 38px;
  a {
    margin-right: 2px;
  }
  img {
    width: 26px;
    height: 26px;
  }
}

.Legacy-wrap {
  display: flex;
  flex-direction: column;

  .Legacy {
    font-size: 12px;
    color: #cccccc;
  }
}
@media (max-width: 500px) {
  .lambfoot {
    padding: 0px 15px;
  }
  .ulcon {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-left: 25px;
    margin-right: 25px;
  }
  .ul {
    display: block;
    padding-left: 0px;
    margin-bottom: 58px;

    li {
      width: 90px;
    }
  }

  .footlogo {
    text-align: center;
  }
  .footshare {
    text-align: center;
  }
  .Copyrights {
    text-align: center;
    margin-bottom: 84px;
  }
  .Legacy-wrap {
    display: flex;
    flex-direction: column;

    .Legacy {
      font-size: 12px;
      color: #cccccc;
    }
  }
}
</style>
